module.exports = __webpack_public_path__ + "static/media/instructor3.75408f3b.png";